module.exports = __webpack_public_path__ + "img/home_banner.26e4821d.png";